import React from 'react';
import { Box } from '@mui/material';

import mixinSx from '@watershed/style/mixinSx';
import Wordmark from '@watershed/ui-core/components/Wordmark';

interface AnimatedWordmarkProps {
  size: number;
  color?: string;
  appearsCollapsed: boolean;
}

export const AnimatedWordmark = ({
  size,
  color,
  appearsCollapsed,
}: AnimatedWordmarkProps) => {
  // Total letters in "Watershed"
  const totalLetters = 9;

  // Generate style object for each letter
  const letterStyles: Record<string, React.CSSProperties> = {};

  // The SVG paths in the Wordmark are in reverse order compared to the word
  // W is the 9th path (last), a is 1st, etc.
  const pathOrder = [9, 1, 2, 3, 4, 5, 6, 7, 8]; // W, a, t, e, r, s, h, e, d

  pathOrder.forEach((pathIndex, letterIndex) => {
    // For disappearing, we want d→W (last to first)
    // For appearing, we want W→d (first to last)
    const delayIndex = appearsCollapsed
      ? totalLetters - 1 - letterIndex // When collapsing, reverse order (d first, then W last)
      : letterIndex; // When expanding, normal order (W first, then d last)

    const expandAnimation = `transform 150ms ease-in ${
      delayIndex * 5
    }ms, opacity 150ms ease-in ${delayIndex * 30}ms`;
    const collapseAnimation = `transform 100ms ease-out ${
      delayIndex * 5
    }ms, opacity 50ms ease-out ${delayIndex * 5}ms`;

    letterStyles[`& path:nth-of-type(${pathIndex})`] = {
      opacity: appearsCollapsed ? 0 : 1,
      transform: appearsCollapsed
        ? `translateX(${-10}px) scaleX(0.7)`
        : 'translateX(0) scaleX(1)',
      transition: appearsCollapsed ? collapseAnimation : expandAnimation,
    };
  });

  return (
    <Box
      sx={mixinSx(
        {
          position: 'relative',
          paddingLeft: appearsCollapsed ? 0 : 0.5,
          '& path': { transformOrigin: 'left center' },
        },
        letterStyles
      )}
    >
      <Wordmark size={size} color={color} />
    </Box>
  );
};
